import { parseErrorResponse } from '../../utils/responseHandler';

export const deleteBatchItem = async (id, token) => {
  try {
    const response = await fetch(`/api/batchItems/${id}`, {
      method: 'delete',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': token,
      },
    });
    if (!response.ok) {
      return await parseErrorResponse(response);
    }
    const body = await response.json();
    return body;
  } catch (error) {
    console.error(`Error in deleteBatchItem: ${error}`);
    return {
      success: false,
      message: error.message || 'Failed to delete batch item',
    };
  }
};
